export default __webpack_public_path__ + "static/media/vaibhav.c0d240a2.png";